import React, { useState } from "react";
import { X } from "lucide-react";
import "./RejectDialog.css";

interface RejectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (motif: string) => void;
  isLoading?: boolean;
}

const REJECTION_REASONS = [
  "Données incomplètes",
  "Valeurs incohérentes",
  "Erreur de période ou de date",
  "Unité de mesure incorrecte",
  "Autre",
];

const RejectDialog: React.FC<RejectDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [selectedReason, setSelectedReason] = useState<string>("");
  const [customReason, setCustomReason] = useState<string>("");

  const handleConfirm = () => {
    const motif = selectedReason === "Autre" ? customReason.trim() : selectedReason;

    if (!motif) {
      alert("Veuillez sélectionner ou saisir un motif de refus");
      return;
    }

    onConfirm(motif);
  };

  const handleClose = () => {
    if (!isLoading) {
      setSelectedReason("");
      setCustomReason("");
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="reject-dialog-overlay" onClick={handleClose}>
      <div className="reject-dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="reject-dialog-header">
          <h2 className="reject-dialog-title">Motif de refus</h2>
          <button
            className="reject-dialog-close"
            onClick={handleClose}
            disabled={isLoading}
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>

        <div className="reject-dialog-body">
          <label className="reject-dialog-label">Sélectionnez le motif de refus :</label>
          <select
            className="reject-dialog-select"
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.target.value)}
            disabled={isLoading}
          >
            <option value="">-- Choisir un motif --</option>
            {REJECTION_REASONS.map((reason) => (
              <option key={reason} value={reason}>
                {reason}
              </option>
            ))}
          </select>

          {selectedReason === "Autre" && (
            <div className="reject-dialog-custom-reason">
              <label className="reject-dialog-label">Précisez le motif :</label>
              <textarea
                className="reject-dialog-textarea"
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Saisissez le motif de refus..."
                rows={4}
                disabled={isLoading}
              />
            </div>
          )}
        </div>

        <div className="reject-dialog-footer">
          <button
            className="reject-dialog-btn reject-dialog-btn-cancel"
            onClick={handleClose}
            disabled={isLoading}
          >
            Annuler
          </button>
          <button
            className="reject-dialog-btn reject-dialog-btn-confirm"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectDialog;
